import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

/**
 * Dynamic namespace-based translation loader.
 *
 * File structure:
 *   locales/en/common.json
 *   locales/en/nav.json
 *   locales/it/common.json
 *   locales/it/nav.json
 *   ...
 *
 * Each JSON file = one namespace. At runtime they're merged into a single
 * `translation` object per language so ALL existing `t('nav.login')`,
 * `t('common.popularCountries')` calls work unchanged.
 */

type TranslationFile = Record<string, Record<string, unknown>>;

const localeModules = import.meta.glob<TranslationFile>('./locales/*/*.json', {
  eager: true,
  import: 'default',
});

const resources: Record<string, { translation: Record<string, Record<string, unknown>> }> = {};

for (const filePath of Object.keys(localeModules)) {
  // filePath = "./locales/en/common.json" or "./locales/it/nav.json"
  const match = /\.\/locales\/([^/]+)\/(.+)\.json$/.exec(filePath);
  if (!match) continue;

  const [, lang, namespace] = match;

  if (!resources[lang]) {
    resources[lang] = { translation: {} };
  }

  resources[lang].translation[namespace] = localeModules[filePath];
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });
